var _path, _rect, _path2, _circle, _circle2, _circle3, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTaskDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 271,
    height: 131,
    viewBox: "0 0 271 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M270.5 129H0V131H270.5V129Z",
    fill: "#80CBC4",
    mask: "url(#path-1-outside-1_150_8485)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 270,
    height: 130,
    fill: "#E0F2F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M125 130.5H125.5V130V36C125.5 32.4101 122.59 29.5 119 29.5H24C20.4101 29.5 17.5 32.4101 17.5 36V130V130.5H18H125Z",
    fill: "#CEEAE8",
    stroke: "#80CBC4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 45,
    r: 4,
    fill: "#80CBC4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 45,
    r: 4,
    fill: "#80CBC4"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 45,
    r: 4,
    fill: "#80CBC4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 104C30 102.895 30.8954 102 32 102H36C37.1046 102 38 102.895 38 104V130H30V104Z",
    fill: "#80CBC4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45 68C45 66.8954 45.8954 66 47 66H51C52.1046 66 53 66.8954 53 68V130H45V68Z",
    fill: "#80CBC4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60 88C60 86.8954 60.8954 86 62 86H66C67.1046 86 68 86.8954 68 88V130H60V88Z",
    fill: "#80CBC4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M75 100C75 98.8954 75.8954 98 77 98H81C82.1046 98 83 98.8954 83 100V130H75V100Z",
    fill: "#80CBC4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M90 77C90 75.8954 90.8954 75 92 75H96C97.1046 75 98 75.8954 98 77V130H90V77Z",
    fill: "#80CBC4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M105 118C105 116.895 105.895 116 107 116H111C112.105 116 113 116.895 113 118V130H105V118Z",
    fill: "#80CBC4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M252 130.5H252.5V130V36C252.5 32.4101 249.59 29.5 246 29.5H142C138.41 29.5 135.5 32.4101 135.5 36V130V130.5H136H252Z",
    fill: "#CEEAE8",
    stroke: "#80CBC4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M191.5 62.9891C191.5 61.5088 191.5 60.7686 191.136 60.1704C190.846 59.6929 190.265 59.2412 189.731 59.0779C189.061 58.8733 188.437 59.0323 187.189 59.3502C175.296 62.3806 166.5 73.1633 166.5 86.0003C166.5 101.188 178.812 113.5 194 113.5C197.587 113.5 201.014 112.814 204.156 111.564C205.351 111.089 205.949 110.851 206.371 110.292C206.707 109.846 206.912 109.139 206.867 108.582C206.809 107.884 206.374 107.285 205.504 106.088L191.994 87.493C191.684 87.0764 191.5 86.5598 191.5 86.0003V62.9891Z",
    fill: "#80CBC4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M217.011 88.5003C218.491 88.5003 219.232 88.5003 219.83 88.8639C220.307 89.154 220.759 89.7353 220.922 90.2696C221.127 90.9391 220.968 91.5627 220.65 92.8101C219.631 96.8129 217.733 100.465 215.174 103.549C214.35 104.542 213.938 105.039 213.276 105.267C212.747 105.449 212.012 105.425 211.496 105.21C210.85 104.939 210.415 104.34 209.543 103.141L201.214 91.6759C200.469 90.6512 200.097 90.1388 200.11 89.711C200.122 89.3387 200.299 88.9909 200.594 88.7626C200.932 88.5003 201.565 88.5003 202.832 88.5003H217.011Z",
    fill: "#80CBC4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M196.5 62.9891C196.5 61.5088 196.5 60.7687 196.864 60.1704C197.154 59.6929 197.735 59.2412 198.269 59.0779C198.939 58.8733 199.563 59.0323 200.811 59.3502C210.526 61.8256 218.175 69.4741 220.65 79.1898C220.968 80.4376 221.127 81.0615 220.922 81.731C220.759 82.2653 220.307 82.8466 219.83 83.1367C219.232 83.5003 218.492 83.5003 217.011 83.5003L198.5 83.5003C197.8 83.5003 197.45 83.5003 197.183 83.3641C196.947 83.2442 196.756 83.053 196.636 82.8178C196.5 82.5504 196.5 82.2004 196.5 81.5003V62.9891Z",
    fill: "#80CBC4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 41,
    width: 18,
    height: 8,
    rx: 4,
    fill: "#80CBC4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskDashboard);
export default __webpack_public_path__ + "static/media/task-dashboard.67c8e5b9ded451b1453f89caacb8f7ca.svg";
export { ForwardRef as ReactComponent };